// ABOUTME: Heading component with consistent typography variants
// ABOUTME: Supports semantic level separation (as) from visual size (level)

import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import type { VariantProps } from "class-variance-authority"
import { cn } from "@shared/lib/utils"
import { headingVariants } from "./CHeading.variants"

type HeadingTag = "h1" | "h2" | "h3" | "h4" | "h5" | "h6"

interface CHeadingProps extends React.HTMLAttributes<HTMLHeadingElement>, VariantProps<typeof headingVariants> {
  as?: HeadingTag
  asChild?: boolean
}

const CHeading = React.forwardRef<HTMLHeadingElement, CHeadingProps>(
  ({ className, level, weight, as, asChild = false, ...props }, ref) => {
    const semanticLevel = level === "page" ? "h1" : level
    const Tag = asChild ? Slot : (as ?? semanticLevel ?? "h1")

    return (
      <Tag
        ref={ref}
        className={cn(headingVariants({ level, weight, className }))}
        {...props}
      />
    )
  },
)

CHeading.displayName = "CHeading"

export { CHeading }
export type { CHeadingProps }
